import type { Asset, Post } from '$lib/api/rpc';
import { textExtensions } from '$textEditor/textExtensions';
import { generateJSON, type JSONContent } from '@tiptap/core';

export const postToTipTapSchema = (post: Post) => {
	const json: JSONContent = { type: 'doc', content: [] };

	const blocks = post.children;
	blocks.forEach((block) => {
		if (block.type === 'text') {
			json.content?.push(generateJSON(block.body, textExtensions()));
		} else if (block.type === 'link' || block.type === 'document' || block.type === 'widget') {
			json.content?.push({
				type: `hubs${block.type.charAt(0).toUpperCase().concat(block.type.slice(1))}Component`,
				attrs: { post: block },
			});
		} else if (block.type === 'video') {
			json.content?.push({
				type: `hubsDocumentComponent`,
				attrs: { post: block },
			});
		} else if (block.type === 'photo') {
			const image = {
				type: `hubsImageComponent`,
				attrs: { post: block, align: 'full-width', url: '' },
			};
			if (block.etc.align) {
				image.attrs.align = 'align-'.concat(block.etc.align);
			}
			if (block.etc.link_url) {
				image.attrs.url = block.etc.link_url;
			}
			json.content?.push(image);
		} else if (block.type === 'gallery') {
			if (!block.children || block.children.length === 0) return;
			const gallery = {
				type: `hubsGalleryComponent`,
				attrs: {
					images: [] as Asset[],
					title: block.children[0].title || '',
					description: block.children[0].body || '',
					loading: false,
				},
			};
			block.children.forEach((image) => {
				if (image.type !== 'photo') return;
				gallery.attrs.images.push(image);
			});
			json.content?.push(gallery);
		}
	});
	return json;
};
